import { Box, styled } from '@mui/material';
import {
  LOCATION_PAGE_CONTENT_PADDING_LEFT,
  LOCATION_PAGE_CONTENT_PADDING_RIGHT,
  LOCATION_PAGE_CONTENT_VERTICAL_PADDING,
} from 'src/constants';

export const Container = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding: 0 !important;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  align-items: stretch;
`;

export const Content = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: ${LOCATION_PAGE_CONTENT_VERTICAL_PADDING}px
    ${LOCATION_PAGE_CONTENT_PADDING_RIGHT}px
    ${LOCATION_PAGE_CONTENT_VERTICAL_PADDING}px
    ${LOCATION_PAGE_CONTENT_PADDING_LEFT}px;
  min-height: 0;
  overflow: auto;
`;
